import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgBalanceOutline = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      clipRule="evenodd"
      d="M24.25 13.286v5.02a1 1 0 0 1-1 1l-.001 2.98a2 2 0 0 1-2 2h-19a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2h1.056l5.293-5.293a1 1 0 0 1 1.415 0l2.82 2.82 1.822-1.82a1 1 0 0 1 1.414 0l4.293 4.293h.887a2 2 0 0 1 2 2v3a1 1 0 0 1 1 1m-22.001-4h19v3h-6.185a3.51 3.51 0 1 0 0 7.02h6.185v2.98h-19zm12.815 5a1.51 1.51 0 0 0 0 3.02h7.186v-3.02zm.242-7h2.228l-2.172-2.172-1.114 1.114zm-6-3.172 3.171 3.171H6.134z"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path d="M16.249 15.796a1 1 0 1 1-2 0 1 1 0 0 1 2 0" fill={props.color} />
  </Svg>
);
const Memo = memo(SvgBalanceOutline);
export default Memo;
